import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Box, Typography } from "@mui/material";
import { NoDataContainer } from "../../../Common/styles/table";
import { groupPieColors } from "../../../Dashboard/DashboardContent/dashboard";
import { DashboardCardStyle } from "../../../Dashboard/DashboardContent/style";

const CustomPieTooltip = ({ active, payload }: any) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const data = payload[0].payload;

  return (
    <Box
      sx={{
        backgroundColor: "#FFF",
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: data.color,
          }}
        />
        <Typography variant="caption" fontWeight={600} color="text.primary">
          {data.label}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary">
        Count: {data.valueLabel}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
        ({data.value}%)
      </Typography>
    </Box>
  );
};

const GenderPieChart = ({ data }: any) => {
  const originalPieData = data?.data || [];

  const filteredPieData = originalPieData
    .map((item: any, index: number) => ({
      ...item,
      originalIndex: index,
      color: groupPieColors[index % groupPieColors.length],
    }))
    .filter((item: any) => item.value > 0);

  return (
    <Box sx={DashboardCardStyle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          color="text.primary"
        >
          {data?.title}
        </Typography>
        {/* <Box>
          <IconButton onClick={(e) => handleOptionsClick(e, data)}>
            <MoreVert />
          </IconButton>
        </Box> */}
      </Box>
      {filteredPieData.length > 0 ? (
        <Box
          sx={{
            height: "400px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            maxWidth: "100%",
          }}
        >
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
            <ResponsiveContainer width={300} height={300}>
              <PieChart>
                <defs>
                  {groupPieColors.map((color: string, index: number) => (
                    <linearGradient
                      key={`pieGradient-${index}`}
                      id={`pieGradient-${index}`}
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop offset="0%" stopColor={color} stopOpacity={0.95} />
                      <stop offset="50%" stopColor={color} stopOpacity={0.75} />
                      <stop
                        offset="100%"
                        stopColor={color}
                        stopOpacity={0.55}
                      />
                    </linearGradient>
                  ))}
                </defs>
                <Pie
                  data={filteredPieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={120}
                  paddingAngle={2}
                  cornerRadius={4}
                  dataKey="value"
                  stroke="#FFF"
                  strokeWidth={2}
                >
                  {filteredPieData.map((entry: any) => (
                    <Cell
                      key={`cell-${entry.originalIndex}`}
                      fill={`url(#pieGradient-${
                        entry.originalIndex % groupPieColors.length
                      })`}
                    />
                  ))}
                </Pie>
                <Tooltip content={<CustomPieTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </Box>
          {/* Custom Legend */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {filteredPieData.map((item: any, index: number) => (
              <Box
                key={item.id || index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    backgroundColor: item.color,
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "13px",
                    color: "#6B7280",
                    fontWeight: 500,
                    minWidth: "100px",
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "13px",
                    color: "#111928",
                    fontWeight: 600,
                  }}
                >
                  {item.valueLabel}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
    </Box>
  );
};
export default GenderPieChart;
